import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronLeftFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.78 11.96L14.14 4.6L15.62 6.08L9.74 11.96L15.62 17.84L14.14 19.32L6.78 11.96Z" />
    </SvgIcon>
  );
});
